import shortid from 'shortid';
import * as trackerIds from '../constants/trackerIds';
import { getGlobalLogger } from '@zg-rentals/logger-base';

export interface initTracker {
  drymode: boolean;
  id: string;
  name?: string;
  type?: string;
}

export interface resultType {
  success: boolean | Record<string, unknown>;
  data: object;
}

export default class Tracker {
  public drymode: boolean;
  public id: string;
  public logger = getGlobalLogger();
  public name: string;
  public type: string;

  constructor({ id, drymode, type, name }: initTracker) {
    this.id = id || '';
    this.drymode = drymode || false;
    this.type = type || '';
    this.name = name || trackerIds.names[id as keyof typeof trackerIds.names] || shortid.generate();

    this.logger?.debug(
      {
        name: this.name,
        id: this.id,
      },
      'created new tracker',
    );
  }

  public result(success: boolean | Record<string, unknown>, data: object = {}): resultType {
    return {
      success,
      data,
    };
  }

  public stopDisabledTracker = (): void => {
    return;
  };

  public renderHtmlInBody = (): string => {
    return '';
  };
  public renderHtmlInHead: (options?: Record<string, unknown>) => string = (): string => {
    return '';
  };
}
